<h3 mat-dialog-title>Блокировка пользователя</h3>
<div mat-dialog-content>
  <p>Вы действительно хотите заблокировать пользователя?</p>
</div>
<div mat-dialog-actions align="end">
  <button mat-button
          (click)="onCancel()">Отмена
  </button>
  <button mat-flat-button color="warn"
          cdkFocusInitial
          (click)="onSubmit()">Заблокировать
  </button>
</div>
